import React, { useEffect, useState, useRef } from "react";
import "../css/constants.css"
import { motion, useViewportScroll, useTransform } from "framer-motion";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { FaArrowRight } from 'react-icons/fa';

import HeroImg from "../assets/images/lol.png";
import PicRow1 from "../assets/images/rapide.png";
import PicRow2 from "../assets/images/appel-telephonique.png";
import PicRow3 from "../assets/images/bouclier.png";
import Concierge1 from "../assets/images/BRAI04h.jpg";
import Concierge2 from "../assets/images/B9730226902Z.1_20220310201930_000+GRMK2KTSG.3-0.jpg";
import Concierge3 from "../assets/images/seuls-deux-patients-medicalises-peuvent-etre-transportes-a-bord-du-piaggio-aventi-photo-er-lionel-vadam-1587571277.jpg";
import Concierge4 from "../assets/images/Unknown_upscayl_5x_realesrgan-x4plus.webp";
import Concierge5 from "../assets/images/665ddd9043906545e7df41bb_Air-Ambulance-medevac.jpg";
import Concierge6 from "../assets/images/42421836.jpeg";
import Concierge7 from "../assets/images/B9727179056Z.1_20210528122603_000+GOJI79C6R.1-0.jpg";
import Concierge8 from "../assets/images/photo ouverture helico.JPG";
import Concierge9 from "../assets/images/images_upscayl_3x_realesrgan-x4plus.webp";
import Transition from "../components/Transition";
import {useNavigate} from "react-router-dom";
import FaqJson from "../assets/jsons/faq.json";
import ConciergerieJson from "../assets/jsons/sanitary.json";
import FlightsJson from "../assets/jsons/sanitaryFlights.json";
import ServicesJson from "../assets/jsons/services.json";
import TestimonialsJson from "../assets/jsons/testimonials.json";
import GlobalJson from "../assets/jsons/Global.json";
import {ChevronDown} from "lucide-react";

const GOLD = "#C1A45F";

const services = [
    {
        title: "Réactivité absolue",
        desc: "Nous répondons et organisons en quelques minutes, 24/7.",
        img: PicRow1,
    },
    {
        title: "Disponibilité sur-mesure",
        desc: "Un interlocuteur unique, présent à chaque étape.",
        img: PicRow2,
    },
    {
        title: "Discrétion & sécurité",
        desc: "Standards premium de sécurité et confidentialité.",
        img: PicRow3,
    },
];

const flights = [
    {
        title: "PARIS → GENÈVE",
        aircraft: "Citation CJ4 Light Jet",
        img: Concierge1,
        description: [
            "Le téléphone a sonné la veille au soir.",
            "Un rendez-vous d’affaires crucial devait être organisé à Genève...",
            "À 7h45, notre client arrive directement au Terminal privé du Bourget, sans file d'attente.",
        ],
        quote: "Une extension naturelle de sa journée, optimisée sans jamais forcer le rythme.",
    },
    {
        title: "NICE → IBIZA",
        aircraft: "Phenom 300",
        img: Concierge2,
        description: [
            "Une idée folle devient réalité : partir pour Ibiza cet après-midi.",
            "Cabine préparée : champagne millésimé, playlist lounge, pivoines fraîches.",
            "À l’atterrissage, une voiture les attend déjà à l’hôtel soigneusement réservé.",
        ],
        quote: "Une fugue élégante, improvisée, intense — une parenthèse enchantée.",
    },
    {
        title: "PARIS → NEW YORK",
        aircraft: "Gulfstream G650",
        img: Concierge3,
        description: [
            "Le lancement d'une filiale new-yorkaise : une traversée transformée en événement.",
            "Cabine métamorphosée : lits en coton égyptien, dîner gastronomique, animations pour enfants.",
            "À Teterboro, Manhattan scintille dans la nuit.",
        ],
        quote: "Un cocon d’attention, de douceur, d’élégance absolue.",
    },
];

const testimonials = [
    {
        name: "Lucien D.",
        role: "Dirigeant",
        quote:
            "Avanty Jet a transformé un déplacement banal en un moment d’exception. Discrétion, précision, excellence.",
    },
    {
        name: "Élodie S.",
        role: "Influenceuse voyage",
        quote:
            "Jamais je n’avais vécu un service aussi personnalisé — du sur-mesure à l’état pur.",
    },
];

function SectionTitle({ eyebrow, title, subtitle }) {
    return (
        <div className="text-center">
            {eyebrow && <p className="uppercase text-sm tracking-widest text-white/60 mb-2">{eyebrow}</p>}
            <h2 className="text-3xl sm:text-4xl font-extrabold" style={{ color: GOLD }}>{title}</h2>
            {subtitle && <p className="mt-3 text-white/80 max-w-4xl mx-auto">{subtitle}</p>}
        </div>
    );
}

function ImageCarousel({ images, height = "h-96" }) {
    const [index, setIndex] = useState(0);
    useEffect(() => {
        const t = setInterval(() => setIndex((i) => (i + 1) % images.length), 4500);
        return () => clearInterval(t);
    }, [images.length]);
    return (
        <div className="relative w-full rounded-2xl overflow-hidden shadow-xl">
            <img src={images[index]} alt={`carousel-${index}`} className={`w-full object-cover ${height}`}/>
            <div className="absolute bottom-4 left-4 flex gap-2">
                {images.map((_, i) => (
                    <button
                        key={i}
                        onClick={() => setIndex(i)}
                        className={`w-10 h-2 rounded-full ${i === index ? "bg-white" : "bg-white/40"}`}
                    />
                ))}
            </div>
        </div>
    );
}

function DemanderDevisButton({language}) {
    const navigate = useNavigate();

    return (
        <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} className="flex justify-center cursor-pointer">
            <a
                onClick={() => navigate("/#quotation")}
                className="px-10 py-4 rounded-full bg-white text-black font-semibold shadow-lg flex items-center hover:bg-gray-100 transition"
            >
                {GlobalJson.availableLanguages[language].ctaButton}
                <FaArrowRight className="ml-2" />
            </a>
        </motion.div>
    );
}

export default function MainContent({ language, setLanguage }) {
    const { scrollY } = useViewportScroll();
    const y = useTransform(scrollY, [0, 600], [0, -120]);
    const navigate = useNavigate()
    const faqs = [
        {
            question: "Dans quels cas proposez-vous des vols sanitaires ?",
            answer: `Avanty Jet organise des vols sanitaires pour :
• Rapatriements médicaux d’urgence.
• Transferts de patients stables ou critiques entre hôpitaux.
• Évacuations médicales internationales.
• Transport de blessés ou malades nécessitant une surveillance spécifique pendant le vol.`
        },
        {
            question: "Quel type d'appareil est utilisé pour les vols sanitaires ?",
            answer: `Nous utilisons principalement des jets privés configurés en ambulance aérienne (Learjet 45 Medevac, Citation Bravo ambulance, etc.), équipés de :
• Lits médicalisés.
• Moniteurs vitaux, respirateurs, équipements de réanimation.
• Matériel adapté aux besoins adultes, pédiatriques ou néonatals.`
        },
        {
            question: "Y a-t-il du personnel médical à bord ?",
            answer: `Oui.
Chaque vol sanitaire est encadré par une équipe médicale spécialisée, adaptée à la pathologie du patient :
• Médecins urgentistes, réanimateurs ou spécialistes (cardiologie, pédiatrie, etc.).
• Infirmiers formés aux évacuations aéroportées.
• Personnel bilingue si nécessaire selon la destination.`
        },
        {
            question: "En combien de temps pouvez-vous organiser un vol sanitaire ?",
            answer: `Dès réception de votre demande complète, Avanty Jet s'engage à présenter une solution sous 60 minutes maximum.
En cas d’urgence extrême, notre cellule médicale est mobilisable immédiatement pour enclencher l'organisation logistique et médicale.`
        },
        {
            question: "Que faut-il fournir pour lancer un vol médicalisé ?",
            answer: `Lors de votre demande, nous aurons besoin de :
• Un résumé médical récent (nature de la pathologie, besoin d'oxygène, état du patient).
• Le lieu de départ et la destination souhaitée.
• Le niveau d'urgence estimé par un médecin (si disponible).
• Vos coordonnées téléphoniques pour un contact direct.`
        },
        {
            question: "Puis-je accompagner le patient durant le vol ?",
            answer: `Oui.
Dans la majorité des cas, un ou deux accompagnants sont autorisés à voyager avec le patient, selon l’état médical et la capacité de l’appareil.
Votre gestionnaire vous précisera ces éléments dès validation de la mission.`
        },
        {
            question: "Comment est assurée la coordination au sol (ambulances, hôpitaux) ?",
            answer: `Avanty Jet organise la coordination complète entre :
• Les équipes ambulancières au départ et à l'arrivée.
• Les médecins référents dans les hôpitaux concernés.
• Les autorités locales (douanes sanitaires, immigration accélérée si besoin).
Notre objectif : garantir une continuité de soins totale, sans rupture, de lit à lit.`
        },
        {
            question: "Vos vols sanitaires sont-ils confidentiels ?",
            answer: `Absolument.
Toutes les missions sanitaires sont couvertes par des protocoles stricts de confidentialité médicale et personnelle.
Vos informations médicales ne sont communiquées qu’aux professionnels de santé et aux opérateurs strictement nécessaires à l’accomplissement sécurisé de votre mission.`
        }
    ];
    const [openIndex, setOpenIndex] = useState(null);

    const toggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="min-h-screen bg-myDarkBlue text-white font-sans">
            <Navbar language={language} setLanguage={setLanguage} />

            {/* HERO */}
            {/* HERO */}
            <section className="relative h-screen flex items-center justify-center overflow-hidden">
                {/* Image + effet parallax */}
                <motion.div
                    style={{
                        y,
                        willChange: "transform",
                        backgroundImage: `url(${HeroImg})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                    }}
                    className="absolute inset-0 brightness-50"
                />

                {/* Filtre brightness séparé pour éviter de le recalculer à chaque scroll */}
                <div className="absolute inset-0 brightness-50" />

                {/* Dégradé */}
                <div className="absolute inset-0 bg-gradient-to-t from-myDarkBlue via-transparent to-myDarkBlue" />

                {/* Contenu */}
                <div className="relative z-20 max-w-5xl px-6 text-center">
                    <motion.h1
                        initial={{ y: -30, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ duration: 0.8 }}
                        className="text-4xl sm:text-6xl font-serif leading-tight font-bold"
                        style={{ color: GOLD }}
                    >
                        {ConciergerieJson.availableLanguages[language].heroTitle}<br />{ConciergerieJson.availableLanguages[language].heroTitle2}
                    </motion.h1>

                    <motion.p
                        initial={{ y: 30, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ duration: 1 }}
                        className="mt-6 text-lg sm:text-xl max-w-3xl mx-auto text-white"
                    >
                        {ConciergerieJson.availableLanguages[language].heroSubtitle}
                    </motion.p>

                    <div className="mt-8 flex items-center justify-center gap-4 cursor-pointer">
                        <a
                            onClick={() => navigate("/#quotation")}
                            className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-white/85 text-black font-semibold shadow-2xl hover:scale-105 transition-transform"
                        >
                            {ConciergerieJson.availableLanguages[language].heroCTA.primary}
                        </a>
                    </div>
                </div>

                {/* subtle down arrow */}
                <div className="absolute bottom-8 z-30 w-full flex justify-center">
                    <motion.div animate={{ y: [0, 8, 0] }} transition={{ repeat: Infinity, duration: 1.6 }}>
                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 5v14" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M19 12l-7 7-7-7" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </motion.div>
                </div>
            </section>

            {/* CONCIERGERIE */}
            <section className="relative py-24 bg-gradient-to-b from-myDarkBlue via-[#0f172a] to-myDarkBlue overflow-hidden">
                <div className="absolute inset-0">
                    <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.05),transparent_70%)]"></div>
                </div>

                <div className="relative max-w-7xl mx-auto px-6 flex flex-col gap-16 items-center">
                    {/* Titre de section */}
                    <SectionTitle
                        eyebrow={ConciergerieJson.availableLanguages[language].conciergerieEyebrow}
                        title={ConciergerieJson.availableLanguages[language].conciergerieTitle}
                        subtitle={ConciergerieJson.availableLanguages[language].conciergerieSubtitle}
                    />

                    {/* Bloc principal */}
                    <motion.div
                        className="w-full bg-white/5 backdrop-blur-md border border-white/10 rounded-3xl shadow-2xl p-8 md:p-14 relative overflow-hidden"
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        {/* Décoration glow */}
                        <div className="absolute -top-40 -right-40 w-96 h-96 bg-[#C1A45F]/20 rounded-full blur-3xl"></div>
                        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-indigo-500/10 rounded-full blur-3xl"></div>

                        {/* Introduction */}
                        <p className="text-white/90 text-lg leading-relaxed max-w-3xl mx-auto mb-14 text-center">
                            {ConciergerieJson.availableLanguages[language].conciergerieIntro}
                        </p>

                        {/* Grille responsive */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
                            {/* Carrousel gauche */}
                            <div className="flex flex-col gap-6 relative">
                                <ImageCarousel images={[Concierge4, Concierge5, Concierge6]} />
                            </div>

                            {/* Détails et CTA */}
                            <div className="flex flex-col justify-center space-y-8 text-white/80">
                                <ul className="space-y-4">
                                    {ConciergerieJson.availableLanguages[language].conciergerieList.map((item, index) => (
                                        <li
                                            key={index}
                                            className="flex items-start gap-3 text-base md:text-lg group"
                                        >
                                            <span className="w-3 h-3 mt-2 rounded-full bg-[#C1A45F] group-hover:scale-110 transition"></span>
                                            <span>{item}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                        {/* Séparateur */}
                        <div className="border-t border-[#C1A45F]/40 mt-16 mb-12 w-3/4 mx-auto" />

                        {/* CTA */}
                        <div className="flex justify-center mb-14">
                            <motion.a
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.98 }}
                                onClick={() => navigate("/#quotation")}
                                className="px-10 py-4 cursor-pointer rounded-full bg-gradient-to-r from-[#C1A45F] to-[#b2964f] text-black font-semibold shadow-lg hover:shadow-xl transition-all duration-300"
                            >
                                {ConciergerieJson.availableLanguages[language].conciergerieCTA.primary}
                            </motion.a>
                        </div>

                        {/* Second carrousel */}
                        {/* Masonry style */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-14">
                            {[Concierge9, Concierge8, Concierge7].map((img, i) => (
                                <div
                                    key={i}
                                    className="overflow-hidden rounded-2xl shadow-lg group relative"
                                >
                                    <img
                                        src={img}
                                        alt={`Helicopter ${i}`}
                                        className="w-full h-full object-cover transform transition-transform duration-500 group-hover:scale-105"
                                    />
                                </div>
                            ))}
                        </div>
                    </motion.div>
                </div>
            </section>

            {/* IMMERSIVE STORIES */}
            <section className="py-24">
                <div className={"mb-14"}>
                    <SectionTitle
                        title={FlightsJson.availableLanguages[language].sectionTitle}
                    />
                </div>
                <div className="max-w-7xl mx-auto px-6 space-y-20">
                    {flights.map((f, idx) => (
                        <motion.div
                            key={idx}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            className={`flex flex-col lg:flex-row items-center gap-10 ${idx % 2 === 1 ? "lg:flex-row-reverse" : ""}`}
                        >
                            <div className="lg:w-1/2 rounded-3xl overflow-hidden shadow-2xl">
                                <img src={f.img} alt={f.title} className="w-full h-96 object-cover transform transition-transform hover:scale-105" />
                            </div>

                            <div className="lg:w-1/2 space-y-4">
                                <p className="text-sm uppercase tracking-wide text-white/60">{FlightsJson.availableLanguages[language].flights[idx].aircraft}</p>
                                <h3 className="text-2xl font-bold">{FlightsJson.availableLanguages[language].flights[idx].title}</h3>
                                <div className="text-white/75 space-y-2">
                                    {FlightsJson.availableLanguages[language].flights[idx].description.map((d, i) => (
                                        <p key={i}>{d}</p>
                                    ))}
                                </div>
                                <motion.div
                                    whileHover={{ scale: 1.02 }}
                                >
                                    <blockquote
                                        className="mt-4 italic border-l-4 pl-4 border-white/20 bg-black/20 text-white/80"
                                        style={{ borderColor: GOLD}}
                                    >
                                        “{FlightsJson.availableLanguages[language].flights[idx].quote}”
                                    </blockquote>
                                </motion.div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </section>

            {/* Points forts */}
            {/*<div className={"bg-gradient-to-b from-myDarkBlue via-[#0f172a] to-myDarkBlue"}>*/}
                <section className="max-w-7xl mx-auto mb-24 px-8">
                    <h2 className="text-3xl font-semibold mb-8 text-center">{FaqJson.availableLanguages[language].pointsFortTitle}</h2>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-10 text-center">
                        <div className="p-6 border-2 border-[#C1A45F] rounded-xl shadow-sm hover:shadow-md transition  bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.05),transparent_70%)]">
                            <h3 className="text-xl font-semibold mb-3">{FaqJson.availableLanguages[language].pointsFort[0].title}</h3>
                            <p className="leading-relaxed">
                                {FaqJson.availableLanguages[language].pointsFort[0].text}
                            </p>
                        </div>
                        <div className="p-6 border-2 border-[#C1A45F] rounded-xl shadow-sm hover:shadow-md transition bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.05),transparent_70%)]">
                            <h3 className="text-xl font-semibold mb-3">{FaqJson.availableLanguages[language].pointsFort[1].title}</h3>
                            <p className="leading-relaxed">
                                {FaqJson.availableLanguages[language].pointsFort[0].text}
                            </p>
                        </div>
                        <div className="p-6 border-2 border-[#C1A45F] rounded-xl shadow-sm hover:shadow-md transition bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.05),transparent_70%)]">
                            <h3 className="text-xl font-semibold mb-3">{FaqJson.availableLanguages[language].pointsFort[2].title}</h3>
                            <p className="leading-relaxed">
                                {FaqJson.availableLanguages[language].pointsFort[0].text}
                            </p>
                        </div>
                    </div>
                </section>
            {/*</div>*/}

            <div className="max-w-4xl mx-auto px-4 py-12 mb-20">
                <h2 className="text-3xl font-bold text-center mb-8">{FaqJson.availableLanguages[language].faqsTitle}</h2>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border border-gray-200 rounded-2xl shadow-sm transition-all">
                            <button
                                className="w-full flex justify-between items-center px-6 py-4 text-left text-lg font-medium text-white hover:text-[#C1A45F] transition"
                                onClick={() => toggle(index)}
                            >
                                {FaqJson.availableLanguages[language].faqs[index].question}
                                <ChevronDown
                                    className={`h-5 w-5 transform transition-transform duration-300 ${
                                        openIndex === index ? "rotate-180 text-[#C1A45F]" : "text-gray-400"
                                    }`}
                                />
                            </button>
                            <div
                                className={`px-6 pb-4 text-gray-400 text-sm transition-all duration-300 ease-in-out ${
                                    openIndex === index ? "max-h-[1000px] opacity-100" : "max-h-0 overflow-hidden opacity-0"
                                }`}
                            >
                                {FaqJson.availableLanguages[language].faqs[index].answer.split('\n').map((line, i) => (
                                    <p key={i} className="mb-2 whitespace-pre-line leading-relaxed">
                                        {line}
                                    </p>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* BRAND PROMISE */}
            <section className="pt-28 pb-16 bg-gradient-to-b from-myDarkBlue via-[#0f172a] to-myDarkBlue">
                <div className="max-w-7xl mx-auto px-6">
                    <SectionTitle
                        eyebrow={ServicesJson.availableLanguages[language].title1}
                        title={ServicesJson.availableLanguages[language].title2}
                        subtitle={ServicesJson.availableLanguages[language].title3}
                    />

                    <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
                        {services.map((s, i) => (
                            <motion.div
                                key={i}
                                whileHover={{ y: -6 }}
                                className="p-6 rounded-2xl bg-black/20 border border-white/20 shadow-lg "
                                style={{
                                    boxShadow: `
    0 -6px 10px rgba(255, 255, 255, 0.1),
    0 -8px 20px rgba(255, 255, 255, 0.05)
  `
                                }}
                            >
                                <div className="flex items-center gap-4">
                                    <img src={s.img} alt={s.title} className="w-16 h-16" />
                                    <div>
                                        <h4 className="text-xl font-semibold text-white">{ServicesJson.availableLanguages[language].services[i].title}</h4>
                                        <p className="text-white/75 mt-1">{ServicesJson.availableLanguages[language].services[i].desc}</p>
                                    </div>
                                </div>
                                <div className="mt-6 text-sm text-white/60 flex justify-center">
                                    {ServicesJson.availableLanguages[language].services[i].bottom}
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* TESTIMONIALS */}
            <section className="py-16">
                <div className="max-w-7xl mx-auto px-6 text-center">
                    <SectionTitle eyebrow={TestimonialsJson.availableLanguages[language].title} title={TestimonialsJson.availableLanguages[language].subtitle} />

                    <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
                        {testimonials.map((t, i) => (
                            <motion.div
                                key={i}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                whileHover={{ y: -6 }}
                                viewport={{ once: true }}
                                className="relative p-6 rounded-2xl bg-black/20 border border-white/10 overflow-hidden bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.05),transparent_70%)]"
                                style={{
                                    boxShadow: `
    0 -6px 10px rgba(255, 255, 255, 0.1),
    0 -8px 20px rgba(255, 255, 255, 0.05)
  `
                                }}
                            >
                                <div
                                    className="absolute -top-4 left-0 w-full h-4 pointer-events-none"
                                    style={{
                                        boxShadow: "0 0 10px 2px rgba(255, 255, 255, 0.2)",
                                        maskImage: "linear-gradient(to bottom, white, transparent)",
                                        WebkitMaskImage: "linear-gradient(to bottom, white, transparent)"
                                    }}
                                />

                                <p className="italic text-white/80">{TestimonialsJson.availableLanguages[language].testimonials[i].quote}</p>
                                <p className="mt-4 font-semibold text-white">{TestimonialsJson.availableLanguages[language].testimonials[i].author}</p>
                                <p className="text-sm text-white/60">{TestimonialsJson.availableLanguages[language].testimonials[i].role}</p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* FINAL CTA */}
            <section className="pt-10 pb-32 bg-myDarkBlue text-center">
                <h2 className="text-4xl font-extrabold mb-4" style={{ color: GOLD }}>{GlobalJson.availableLanguages[language].ctaTitle}</h2>
                <p className="text-white/80 max-w-2xl mx-auto mb-8">{GlobalJson.availableLanguages[language].contact}</p>
                <div className="flex items-center justify-center gap-4">
                    <DemanderDevisButton language={language}/>
                </div>
            </section>

            <Footer language={language} />
        </div>
    );
}

export function Sanitary({language, setLanguage}) {
    const [isTransitionVisible, setIsTransitionVisible] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsTransitionVisible(false);
        }, 800);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div>
            {isTransitionVisible ? (
                <Transition/>
            ) : (
                <MainContent language={language} setLanguage={setLanguage}/>
            )}
        </div>
    );
}